import { createAsyncThunk } from '@reduxjs/toolkit';

import { ExtendedAxiosRequestConfig } from 'shared/api/types';

import {
    FETCH_ABORTED,
    GLOBAL_CATALOG_ITEMS_PAGE_SIZE,
} from '../../consts/catalogItemsConsts';
import { GlobalCatalogItemsResponse } from '../../types/CatalogItemSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface GlobalCatalogItemsRequestData {
    searchString?: string;
    categoryId?: string;
    page?: number;
    pageSize?: number;
    after?: string;
    propertyId?: string;
    abortController?: AbortController;
}

export const fetchGlobalCatalogItems = createAsyncThunk<
    GlobalCatalogItemsResponse,
    GlobalCatalogItemsRequestData,
    ThunkConfig<string>
>(
    'catalogItem/fetchGlobalCatalogItem',
    async (
        {
            searchString,
            categoryId,
            propertyId,
            page = 1,
            pageSize = GLOBAL_CATALOG_ITEMS_PAGE_SIZE,
            after,
            abortController,
        },
        thunkApi,
    ) => {
        const { extra, rejectWithValue } = thunkApi;

        // if (!searchString) return;

        try {
            const config: ExtendedAxiosRequestConfig = {
                signal: abortController?.signal,
                params: {
                    searchString,
                    categoryId,
                    propertyId,
                    page,
                    pageSize,
                    after,
                },
                keysToNotConvert: ['specifications'],
            };

            const response = await extra.api.get<GlobalCatalogItemsResponse>(
                `/v1/catalogs/search-items`,
                config,
            );

            return response.data;
        } catch (e) {
            const isAborted =
                (e as { code?: string })?.code === 'ERR_CANCELED' ||
                (e as { name?: string })?.name === 'AbortError';
            if (isAborted) {
                return rejectWithValue(FETCH_ABORTED);
            }
            return rejectWithValue('error');
        }
    },
);
